import {useTranslation} from "react-i18next";

function VisionAndMissionPage() {
  const { t } = useTranslation('common');

  return (
    <div id="aboutUsPage" className='page'>
			<div>
				<h1 style={{fontSize: 30}}>
					{t('vision').toUpperCase()}
				</h1>
      	<p>
					{t('visionText')}
      	</p>
			</div>
			<div>
				<h1 style={{fontSize: 30}}>
					{t('mission').toUpperCase()}
				</h1>
      	<p>
					{t('missionText')}
      	</p>
			</div>
    </div>
  );
}

export default VisionAndMissionPage;